import { POST_TEXT_LIMIT } from '../../../packages/domain/src/23-post-continuations.mjs';
import { continuationPreview } from './16-post-continuations.mjs';
import { createDirectChoices } from './15-direct-choices.mjs';
import { LAYOUTS } from '../../../packages/domain/src/04-media.mjs';

/** Edit authored text and media presentation without changing media order. The
 * server validates ownership and the canonical layout/key-photo policy. */
export function editPostDialog(ctx, post) {
  const form = ctx.e('form', 'form-stack');
  const text = ctx.field('textarea', {
    value: post.fullText ?? post.text,
    required: true,
    maxLength: POST_TEXT_LIMIT,
    ariaLabel: ctx.uiText('Edit post text'),
  });
  const layout = createDirectChoices(ctx, {
    label: ctx.uiText('Gallery layout'),
    name: `post-${post.id}-layout`,
    variant: 'gallery',
    value: post.media?.some((media) => media.kind === 'video')
      ? 'carousel'
      : (post.layout ?? 'auto'),
    options: LAYOUTS.filter(
      (value) =>
        !post.media?.some((media) => media.kind === 'video') ||
        ['auto', 'carousel'].includes(value),
    ).map((value) => ({
      value,
      label: {
        auto: 'Automatic composition',
        grid: 'Grid',
        carousel: 'Carousel',
        feature: 'Key photo',
      }[value],
      icon: { auto: 'sparkles', grid: 'grid-2x2', carousel: 'images', feature: 'image' }[value],
    })),
  });
  const lead = createDirectChoices(ctx, {
    label: ctx.uiText('Key photo'),
    name: `post-${post.id}-lead`,
    variant: 'gallery',
    images: true,
    value: post.leadMediaIndex == null ? '' : String(post.leadMediaIndex),
    options: [
      { value: '', label: 'Automatic key photo', icon: 'sparkles' },
      ...(post.media ?? []).flatMap((media, index) =>
        media.kind === 'image'
          ? [
              {
                value: String(index),
                label: `${ctx.uiText('Photo')} ${index + 1} · ${media.alt || post.title || ''}`,
                literal: true,
                image: media.url,
              },
            ]
          : [],
      ),
    ],
  });
  const save = ctx.e('button', 'primary-button', ctx.uiText('Save changes'));
  form.append(text, continuationPreview(ctx, text));
  if (post.media?.length) form.append(layout.node, lead.node);
  form.append(save);
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    save.disabled = true;
    try {
      await ctx.command({
        type: 'edit-post',
        id: post.id,
        text: text.value,
        ...(post.media?.length
          ? {
              layout: layout.value,
              leadMediaIndex: lead.value === '' ? null : Number(lead.value),
            }
          : {}),
      });
      ctx.modal.close();
      ctx.toast(ctx.uiText('Post updated.'));
    } catch (error) {
      ctx.toast(error.message);
      save.disabled = false;
    }
  });
  ctx.dialog('Edit your post', form);
}
